import queryString from 'query-string'
// beastapp://entry?
// beastapp://search?
// beastapp://store/shopId

const REG = /^beastapp:\/\/(\S+)[\?\/]([\S\s]+)/i

const route = {
  'index': '/',
  'shop': '/shop?shopId=',
  'store': '/shop?shopId=',
  'brand': '/product/list?',
  'cate': '/product/list?',
  'search': '/product/list?',
  'retail': '/retail?',
  'article': `/article?articleId=`,
  'customization-list': `/customization/list?`,
  'big-furniture-tips': '/furniture/tips?',
  'shop-story': '/shop/story?',
  'group-purchase': '/group/purchase?',
  'points-benefit': '/points/benefit?',
  'points-mall': '/member/day/points?',
  'category': '/category?',
  'store': '/store?',
  'cart': '/cart?',
  'member': '/my?'
}

const params = {
  'brand': 'brandId'
}

export function getLink (link) {
  console.log(link)
  if (link === 'beastapp://index') {
    link = '/'
  }
  else {
    link = splitQue(link)
  }

  return link
}

function splitQue (query) {
  let que = REG.exec(query)
  console.log(que, "que")
  let type = que[1]
  let search = que[2]
  let name = ''
  // entry
  if (type === 'entry') {
    type = queryString.parse(search).name
  }

  if (type && search) {
    que = matchQue(type, search)
  }

  return que
}

function matchQue (type, query) {
  let que = ''
  type = type.split('/')

  const path = route[type[0]]
  const pid = params[type[0]]

  if (path) {
    que = type[1] && pid
      ? `${path}${pid}=${type[1]}&${query}`
      : pid
        ? `${path}${pid}=${query}`
        : `${path}${query}`
  }
  else {
    que = `/${type[0].replace('-', '/')}`
  }

  return que
}



// WEBPACK FOOTER //
// ./static/components/app-menu/util.js